var BufferPromptHandler = require('bufferprompthandler');


var ConversationPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function (options) {
        BufferPromptHandler.prototype.bindMessageHandlers.call(this, options);
        this.model.bind('deleteConfirm', this.deleteConfirm, this);
        this.model.bind('renamePrompt', this.renamePrompt, this);
        this.model.bind('renameError', this.renameError, this);
    },
    deleteConfirm: function (callback) {
        var confirmText = "Are you sure you want to delete your history with " + this.model.getName();
        var overlay = this.confirm(confirmText, _.bind(function () {
            this.model.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'conversation_delete_confirm';
        this.triggerAdd(overlay);
    },
    renameError: function (newName, response, callback) {
        var msg = '';
        switch (response.message) {
        case 'invalid_name':
            msg = 'You must choose a valid nick name';
            break;
        case 'not_conversation':
            msg = 'You can only rename private messages';
            break;
        case 'name_exists':
            msg = 'That name is already taken';
            break;
        default:
            msg = 'Error renaming: ' + response.message;
        }
        this.renamePrompt(newName, callback, msg);
    },
    renamePrompt: function (promptName, callback, error) {
        var promptText = "Choose a new name for this conversation";
        var overlay = this.prompt(promptText, _.bind(function (newName) {
            this.model.rename(newName, callback);
        }, this), promptName, {
            error: error,
            keepFocus: false
        });
        overlay.className = 'conversation_rename_prompt';
        this.triggerAdd(overlay);
    }
});


module.exports = ConversationPromptHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/conversationprompthandler.js
// module id = X9Qn
// module chunks = 1